import { FilterDsp } from 'components/common/FilterArea/Filters';
import { InputShape, InputSize, InputTheme } from 'components/common/types/Input.types';
import { Store } from 'components/common/types/Store.types';
import { ShadowStyle } from 'consts/shadow';
import { Padding } from 'lib/BaseSelect/BaseSelect.types';
import { Label } from 'lib/Label';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { changeOnlyProgrammaticDealData } from 'store/dealManagement/reducer';
import { useDspSettings } from 'customHooks/useDspSettings';
import { isDspSeatIdRequired } from 'utils/isDspSeatIdRequired';
import DspSeatId from './DspSeatId';
import { useDspSync } from './useDspSync';
import { InputContainer } from '../utils';

export const SelectDsp = (): React.ReactElement => {
  const dispatch = useDispatch();

  const dsp = useSelector((state: Store) => state.dealManagement.programmatic.dsp);
  const isSimplifiedPlanningMode = useSelector(
    (state: Store) => state.dealManagement.plannerSettings.isSimplifiedPlanningMode,
  );
  const bookingStatusCode = useSelector((state: Store) => state.dealManagement.commonDeal.bookingStatusCode);

  const isRequiredDspSeatId = isDspSeatIdRequired(bookingStatusCode);

  const { isWithDspSync, isDspDisabled } = useDspSettings();
  const { dspSeatId, updateDspSeat } = useDspSync();

  return (
    <>
      <InputContainer>
        <Label id="dsp" theme={InputTheme.FLAT_GRAY} label="DSP" isRequired={!isSimplifiedPlanningMode} />
        <Tooltip tooltip={dsp?.name} direction={TooltipDirection.BOTTOM} isHiddenOnFocus>
          <FilterDsp
            dataTestId="async-select-dsp"
            placeholder=""
            selectedValue={dsp}
            onChange={(key, value) => dispatch(changeOnlyProgrammaticDealData({ [key]: value, syncWithDsp: false }))}
            isDisabled={isDspDisabled}
            theme={InputTheme.FLAT_GRAY}
            size={InputSize.EXTRA_SMALL}
            padding={Padding.NONE}
            shadow={ShadowStyle.NONE}
            shape={InputShape.ROUNDED}
          />
        </Tooltip>
        {isWithDspSync && (
          <DspSeatId
            value={dspSeatId}
            onBlur={updateDspSeat}
            isDisabled={isDspDisabled}
            isRequired={isRequiredDspSeatId}
          />
        )}
      </InputContainer>
      {isWithDspSync && (
        <div className="mb-[12px] mx-[24px]">
          <p className="body-sm text-neutral-950-opacity-90 flex bg-primary-600-opacity-10 p-2">
            DV360 and TTD deals are auto-synced via API
          </p>
        </div>
      )}
    </>
  );
};
